var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{staticStyle:{"height":"100%"},attrs:{"span":8}},[_c('div',{staticClass:"order_money"},[_c('div',{staticClass:"head"},[_c('span',[_vm._v("订单金额分布情况")])]),_c('div',{staticClass:"content"},[_c('div',{ref:"chart",staticStyle:{"height":"310px"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }